import type { ComponentType, ReactNode } from "react";

import type { LucideProps } from "lucide-react";

export function EmptyState({ title, description }: { title: string; description: string }) {
  return (
    <div className="rounded-xl border border-dashed px-4 py-10 text-center">
      <p className="font-medium">{title}</p>
      <p className="text-muted-foreground mt-2 text-sm">{description}</p>
    </div>
  );
}

export function EmptyStatePage({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon?: ComponentType<LucideProps>;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24">
      {Icon ? (
        <div className="bg-muted flex size-16 items-center justify-center rounded-full">
          <Icon className="text-muted-foreground size-8" />
        </div>
      ) : null}
      <div className="text-center">
        <h2 className="text-lg font-semibold">{title}</h2>
        {description ? <p className="text-muted-foreground mt-1 text-sm">{description}</p> : null}
      </div>
      {action ?? null}
    </div>
  );
}
